/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AutomatedSearchStatus = {
    Pending: 'PENDING',
    Completed: 'COMPLETED'
} as const;
export type AutomatedSearchStatus = typeof AutomatedSearchStatus[keyof typeof AutomatedSearchStatus];


export function instanceOfAutomatedSearchStatus(value: any): boolean {
    for (const key in AutomatedSearchStatus) {
        if (Object.prototype.hasOwnProperty.call(AutomatedSearchStatus, key)) {
            // @ts-ignore
            if (AutomatedSearchStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AutomatedSearchStatusFromJSON(json: any): AutomatedSearchStatus {
    return AutomatedSearchStatusFromJSONTyped(json, false);
}

export function AutomatedSearchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomatedSearchStatus {
    return json as AutomatedSearchStatus;
}

export function AutomatedSearchStatusToJSON(value?: AutomatedSearchStatus | null): any {
    return value as any;
}

